module.exports = __webpack_public_path__ + "img/9791196552527.23e861fb.jpg";